// Toggle/Switch controller
// Matches @a-safe-digital React Toggle component pattern
// Uses data-state attribute with CSS group selectors for visual changes

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "checkbox"]
  static values = { checked: Boolean }

  connect() {
    // Ensure button state matches checkbox on load
    this.updateButton()
  }

  toggle(event) {
    // Prevent default if event is from button
    if (event) event.preventDefault()

    // Get the checkbox input
    const checkbox = this.checkboxTarget

    // Don't toggle if disabled
    if (checkbox.disabled) return

    // Toggle the checkbox
    checkbox.checked = !checkbox.checked
    this.checkedValue = checkbox.checked

    // Update button to match
    this.updateButton()

    // Dispatch change event from checkbox
    checkbox.dispatchEvent(new Event("change", { bubbles: true }))
  }

  updateButton() {
    if (!this.hasButtonTarget || !this.hasCheckboxTarget) return

    const checkbox = this.checkboxTarget
    const button = this.buttonTarget
    const isChecked = checkbox.checked

    // Update data-state attribute (CSS group selectors handle the rest)
    button.setAttribute("data-state", isChecked ? "on" : "off")

    // Update ARIA
    button.setAttribute("aria-checked", isChecked)
    checkbox.setAttribute("aria-checked", isChecked)
  }
}
